import Vuex from 'vuex';
import Vue from "vue";
import lang from './lang.js';
import noutati from './noutati.js';
import notifications from './notifications.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fontSize: parseFloat(localStorage.getItem('fontSize') || 1.0)
  },
  mutations: {
    setFontSize: (state, fontSize) => {
      if (isNaN(fontSize)) {
        throw new Error('Font size must be a number.');
      }

      if (fontSize < 0.8 || fontSize > 1.4) {
        throw new Error('Font size must be in interval 0.8-1.6');
      }
      state.fontSize = fontSize;
    }
  },
  actions: {
    setFontSize: async ({ commit }, fontSize) => {
      commit('setFontSize', parseFloat(fontSize));
      localStorage.setItem('fontSize', fontSize)
    }
  },
  modules: {
    lang,
    noutati,
    notifications
  },
});
